// src/components/Esim/EsimDetail/EsimPlanDetails.js
import React from "react";
import "./esim-plan-details.scss";

import { FaGlobe, FaCalendarAlt } from "react-icons/fa";

import ActivationSteps from "../ActivationSteps/ActivationSteps";
import CompatibilityInfo from "../Compatibilty/CompatibilityInfo";
import RefundPolicy from "../RefundPolicy/RefundPolicy";

import { useNavigate } from "react-router-dom";
import { requestEsimPreorder } from "../../../requests/esimAPI";
import { toast } from "react-toastify";

/* ✅ Convert bytes → GB */
const bytesToGb = (bytes) => {
  const num = Number(bytes || 0);
  if (!num || !isFinite(num)) return "0.00";
  return (num / 1024 / 1024 / 1024).toFixed(2);
};

const EsimPlanDetails = ({ selectedPackage, showPlanOverview = true }) => {
  const navigate = useNavigate();

  const handleNext = async () => {
    const esimPreorderResult = await requestEsimPreorder(selectedPackage);
    if (!esimPreorderResult) {
      toast.error("Something went wrong, please try again");
      return;
    }
    navigate("/esim/payment-step", { state: { selectedPackage, esimPreorderResult } });
  };

  const gbValue = bytesToGb(selectedPackage?.volume);
  const countriesCount = selectedPackage?.locationNetworkList?.length || 1;
  const validityDays = selectedPackage?.duration || 0;

  return (
    <section className="esim-plan-details-section">
      {/* ✅ Narrow centered card with same width as Activation Steps */}
      {showPlanOverview && (
        <div className="plan-details-card">
          <div className="header-container">
            <h4 className="plan-heading">Plan Details</h4>
          </div>

          {/* ✅ Main data circle (GB) */}
          <div className="plan-circle">
            <div className="outer-circle">
              <div className="inner-circle">
                <span className="plan-data">{gbValue} GB</span>
              </div>
            </div>
          </div>

          {/* ✅ Info Cards */}
          <div className="plan-info-boxes">
            {/* Countries */}
            <div className="info-box">
              <FaGlobe className="info-icon gold" aria-hidden="true" />
              <div className="info-text">
                <span>Countries</span>
                <strong>{countriesCount}</strong>
              </div>
            </div>

            {/* Validity */}
            <div className="info-box">
              <FaCalendarAlt className="info-icon gold" aria-hidden="true" />
              <div className="info-text">
                <span>Validity</span>
                <strong>{validityDays} Days</strong>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Additional Sections */}
      <ActivationSteps />
      <CompatibilityInfo />
      <RefundPolicy />
    </section>
  );
};

export default EsimPlanDetails;
